<template>
  <transition name="modal-fade">
    <div class="custom-modal-wrapper" v-if="visible">
      <div class="custom-modal" :class="[modalSizeClass, { 'modal-term': term }]">
        <!-- Tombol Kembali -->
        <button
          v-if="$listeners.back"
          class="back-btn"
          @click="$emit('back')"
          aria-label="Kembali"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 24 24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>

        <!-- Tombol Tutup -->
        <button
          v-if="$listeners.close"
          class="close-btn"
          @click="$emit('close')"
          aria-label="Tutup modal"
        >
          &times;
        </button>

        <!-- Header: Logo & Title -->
        <div class="modal-header-center" v-if="withLogo || title">
          <img
            v-if="withLogo"
            :src="logoSrc"
            alt="logo"
            class="modal-logo"
          />
          <span v-if="title" class="title-modal">{{ title }}</span>
        </div>

        <!-- Body slot -->
        <div class="custom-modal-body">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'newCustomModal',
  props: {
    visible: { type: Boolean, required: true },
    size: { type: String, default: null },
    term: { type: Boolean, default: false },
    withLogo: { type: Boolean, default: false },
    title: { type: String, default: '' },
    logoSrc: {
      type: String,
      default: () => require('@/assets/images/landing_page/logo-efunding.svg')
    }
  },
  computed: {
    modalSizeClass() {
      if (this.term) return 'modal-large'
      switch (this.size) {
        case 'small': return 'modal-small'
        case 'large': return 'modal-large'
        case 'xl': return 'modal-xl'
        default: return 'modal-default'
      }
    }
  }
}
</script>

<style scoped>
/* Wrapper modal */
.custom-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 73, 144, 0.6);
  overflow-y: auto;
  z-index: 1050;
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Modal dasar */
.custom-modal {
  width: 100%;
  margin: auto;
  background: white;
  border-radius: 8px;
  padding: 2rem;
  position: relative;
  box-sizing: border-box;
  transition: all 0.3s ease;
}

/* Ukuran modal */
.modal-default { max-width: 700px; }
.modal-small { max-width: 400px; }
.modal-large { max-width: 900px; }
.modal-xl    { max-width: 1140px; }

/* Jika prop term aktif */
.modal-term {
  min-height: 80vh;
  padding-top: 3rem;
  padding-bottom: 3rem;
}

/* Tombol kembali */
.back-btn {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  background: none;
  border: none;
  font-size: 1.8rem;
  color: #004990;
  cursor: pointer;
}
.back-btn:hover { color: #002f61; }

/* Tombol tutup */
.close-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: none;
  font-size: 2rem;
  color: #004990;
  cursor: pointer;
  line-height: 1;
}
.close-btn:hover { color: #002f61; }

/* Header tengah */
.modal-header-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 1rem;
}

.modal-logo {
  width: 300px;
}

.title-modal {
  font-weight: 700;
  font-size: 30px;
  margin-bottom: 10px;
  color: #274C8E;
}
</style>


// WEBPACK FOOTER //
// src/components/newCustomModal.vue